:host,
input {
  --uui-textbox-padding: var(--uui-input-padding);
  --uui-textbox-padding-reduce: var(--uui-input-padding-hover);
  --uui-textbox-margin-bottom: 0;
  --uui-textbox-border-radius: var(--uui-input-radius);
  --uui-textbox-color: var(--uui-input-color);
  --uui-textbox-border-color: var(--uui-input-border-color);
  --uui-textbox-border-hover-color: var(--uui-input-border-color-hover);
  --uui-textbox-border-active-color: var(--uui-input-border-color-active);
  --uui-textbox-border-error-color: var(--uui-input-border-color-error);
  --uui-textbox-border-warning-color: var(--uui-input-border-color-warning);
}

:host,
input {
  position: relative;
}

input {
  line-height: var(--uui-default-line-height);
  line-height: 1.25em;
  width: 100%;
  font-family: var(--uui-primary-font-family);
  font-weight: var(--uui-font-weight-normal);
  font-size: var(--uui-default-font-size);
  color: var(--uui-textbox-color);
  padding: var(--uui-textbox-padding);
  box-sizing: border-box;
  background-color: transparent;
  border: 1px solid var(--uui-textbox-border-color);
  border-radius: var(--uui-textbox-border-radius);
  margin-bottom: var(--uui-textbox-margin-bottom);
}

input::placeholder {
  font-family: var(--uui-primary-font-family);
  font-weight: var(--uui-font-weight-normal);
  font-size: var(--uui-default-font-size);
}

input.uui-textbox-has-end-icon {
  padding-right: 2.375em;
  --uui-textbox-padding-reduce: 0.625em 2.3125em 0.625em 0.6875em;
}

input.uui-textbox-has-start-icon {
  padding-left: 2.375em;
  --uui-textbox-padding-reduce: 0.625em 0.6875em 0.625em 2.3125em;
}

input.uui-textbox-has-start-icon.uui-textbox-has-end-icon {
  --uui-textbox-padding-reduce: 0.625em 2.3125em 0.625em 2.3125em;
}

.uui-slotted-icon-container {
  position: absolute;
  display: grid;
  justify-content: center;
  align-content: center;
  top: 0;
  height: 100%;
}

.uui-slotted-icon-container-end {
  right: 0.75em;
}

.uui-slotted-icon-container-start {
  left: 0.75em;
}

/**
  focus state
**/
input:not(:disabled):focus,
input:not(:disabled):active {
  box-shadow: 1px 0 var(--uui-textbox-border-active-color),
    -1px 0 var(--uui-textbox-border-active-color),
    0 1px var(--uui-textbox-border-active-color),
    0 -1px var(--uui-textbox-border-active-color);
  outline: none;
}

/**
  error state
**/
input.error {
  --uui-textbox-border-color: var(--uui-textbox-border-error-color);
}

input.error:hover,
input.error:focus,
input.error:active {
  --uui-textbox-border-color: var(--uui-textbox-border-error-color);
  box-shadow: 1px 0 var(--uui-textbox-border-error-color),
    -1px 0 var(--uui-textbox-border-error-color),
    0 1px var(--uui-textbox-border-error-color),
    0 -1px var(--uui-textbox-border-error-color);
  outline: none;
}

/**
  warning state
**/
input.warning {
  --uui-textbox-border-color: var(--uui-textbox-border-warning-color);
}

input.warning:hover,
input.warning:focus,
input.warning:active {
  --uui-textbox-border-color: var(--uui-textbox-border-warning-color);
  box-shadow: 1px 0 var(--uui-textbox-border-warning-color),
    -1px 0 var(--uui-textbox-border-warning-color),
    0 1px var(--uui-textbox-border-warning-color),
    0 -1px var(--uui-textbox-border-warning-color);
  outline: none;
}

/**
  hover state
**/
input:not(.error):not(.warning):not(:disabled):not(:focus):hover {
  box-shadow: 1px 0 var(--uui-textbox-border-hover-color),
    -1px 0 var(--uui-textbox-border-hover-color),
    0 1px var(--uui-textbox-border-hover-color),
    0 -1px var(--uui-textbox-border-hover-color);
}

/**
  disabled state
**/
input:disabled {
  opacity: var(--uui-disabled-opacity);
}
